import { GetterTree } from "vuex";
import { RootState } from "../types";
import { ReimbursementsState } from "./types";

export const getters: GetterTree<ReimbursementsState, RootState> = {
  getRefresh(state): boolean {
    return state.refresh;
  },
};
